import React, { useContext, createContext, useState } from 'react'

const AppContext = createContext();

const cadastroInitial = {
    tipoAssociado: "Titular",
    titulo: "",
    nome: "",
    dataNascimento: "dd/mm/aaaa",
    sexo: "Masculino",
    estadoCivil: "Solteiro(a)",
    endereco: "",
    bairro: "",
    cidade: "",
    estado: "",
    cep: "",
    rg: "",
    cpf: "",
    telefone: "",
    celular: "",
    email: "",
}

export default function ContextProvider({ children }) {
    const [cadastro, setCadastro] = useState(cadastroInitial);
    const [snackBar, setSnackBar] = useState({ open: false, message: "", severity: "info" })
    const [dialog, setDialog] = useState(false)
    const [globalRefresh, setGlobalRefresh] = useState(0)
    return (
        <AppContext.Provider
            value={{
                cadastroContext: { cadastro, setCadastro, cadastroInitial },
                snackBarContext: { snackBar, setSnackBar },
                dialogContext: { dialog, setDialog },
                globalRefreshContext: { globalRefresh, setGlobalRefresh },
            }}>
            {children}
        </AppContext.Provider>
    )
}

export function useCadastro() {
    const { cadastroContext, globalRefreshContext } = useContext(AppContext)
    const { cadastro, setCadastro, cadastroInitial } = cadastroContext
    const { globalRefresh, setGlobalRefresh } = globalRefreshContext
    const clearCadastro = (tipoAssociado, titulo) => {
        let newObj = {
            nome: "",
            dataNascimento: "dd/mm/aaaa",
            sexo: "Masculino",
            estadoCivil: "Solteiro(a)",
            endereco: "",
            bairro: "",
            cidade: "",
            estado: "",
            cep: "",
            rg: "",
            cpf: "",
            telefone: "",
            celular: "",
            email: "",
            tipoAssociado: tipoAssociado,
            titulo: titulo
        }
        setCadastro(newObj)
        setGlobalRefresh(globalRefresh + 1)
    }
    return { cadastro, setCadastro, clearCadastro }
}

export function useSnackBar() {
    const { snackBarContext } = useContext(AppContext)
    const { snackBar, setSnackBar } = snackBarContext
    return { snackBar, setSnackBar }
}

export function useDialog() {
    const { dialogContext } = useContext(AppContext)
    const { dialog, setDialog } = dialogContext
    return { dialog, setDialog }
}

export function useGlobalRefresh() {
    const { globalRefreshContext } = useContext(AppContext)
    const { globalRefresh, setGlobalRefresh } = globalRefreshContext
    return { globalRefresh, setGlobalRefresh }
}